import { render, staticRenderFns } from "./followUpModal.vue?vue&type=template&id=28ece705&scoped=true"
import script from "./followUpModal.vue?vue&type=script&lang=js"
export * from "./followUpModal.vue?vue&type=script&lang=js"
import style0 from "./followUpModal.vue?vue&type=style&index=0&id=28ece705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ece705",
  null
  
)

export default component.exports